import { createContext, useContext, useMemo } from "react";
import invariant from "invariant";

const AuthenticationCollapsibleFormsContext = createContext();

export const AuthenticationCollapsibleFormsContextProvider = props => {
  const { children, selectedAuthOption, setSelectedAuthOption } = props;

  const contextValue = useMemo(
    () => ({ selectedAuthOption, setSelectedAuthOption }),
    [selectedAuthOption, setSelectedAuthOption]
  );

  return (
    <AuthenticationCollapsibleFormsContext.Provider value={contextValue}>
      {children}
    </AuthenticationCollapsibleFormsContext.Provider>
  );
};

export const useAuthenticationCollapsibleFormsContext = () => {
  const context = useContext(AuthenticationCollapsibleFormsContext);

  invariant(
    context,
    `AuthenticationCollapsibleForm must be used inside
     AuthenticationCollapsibleFormsContextProvider`
  );

  return context;
};
